// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DynProperty } from '@shared/commons/DynProperty';
import { Resources } from '@shared/localizations/Resources';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { QuickTableEditingInfo } from '../elements/QuickTable/QuickTableMisc';
import { BaseItem, ColumnData } from './BaseItem';
import { ColumnParams } from './ColumnParams';
import { TableTotalsVisibility } from './TableTotalsVisibility';
import { QTAlignment } from '../elements/QuickTable/QuickTableColumn';
import { NewsPriority } from '@shared/commons/cache/News';
export class NewsItem extends BaseItem {
    constructor(news, isViewed) {
        super();
        this.news = null;
        this.Disabled = isViewed; // просмотрена ли новость
        if (!isNullOrUndefined(news)) {
            this.news = news;
            if (news.contentIsLink) // есть ссылка в TEXT[115] то в качестве контента отображаем кликабельную ссылку.
             {
                this.QuickTableEditingInfoMap[NewsItem.CONTENT_COL_INDEX] = new QuickTableEditingInfo(DynProperty.LINK);
            }
        }
    }
    getColumnData(column) {
        const value = this.getColumnValue(column);
        let formattedValue = null;
        switch (column) {
            case NewsItem.RECEIVED_COL_INDEX:
                formattedValue = isNullOrUndefined(value) ? '' : DateTimeUtils.formatDate(value, 'DD.MM.YYYY HH:mm:ss');
                break;
            case NewsItem.PRIORITY_COL_INDEX:
                formattedValue = this.getTextPriority(value);
                break;
            default:
                formattedValue = isNullOrUndefined(value) ? '' : value.toString();
                break;
        }
        return new ColumnData(value, formattedValue);
    }
    getColumnValue(column) {
        const news = this.news;
        if (news === null) {
            return null;
        }
        switch (column) {
            case NewsItem.RECEIVED_COL_INDEX:
                return news.received;
            case NewsItem.SOURCE_COL_INDEX:
                return news.source;
            case NewsItem.SUBJECT_COL_INDEX:
                return news.subject;
            case NewsItem.CONTENT_COL_INDEX:
                return news.content;
            case NewsItem.CATEGORY_COL_INDEX:
                return news.category;
            case NewsItem.SYMBOL_COL_INDEX:
                return news.symbol;
            case NewsItem.PRIORITY_COL_INDEX:
                return news.priority;
            default:
                return null;
        }
    }
    getLinkInContent() {
        const news = this.news;
        if (news === null) {
            return null;
        }
        return news.content;
    }
    getNewsID() {
        return this.news ? this.news.GetID() : null;
    }
    getRouteID() {
        return this.news ? this.news.GetRouteID() : null;
    }
    OnNewsDoubleClicked() {
        if (this.news) {
            this.news.OnNewsDoubleClicked();
        }
    }
    getTextPriority(value) {
        switch (value) {
            case NewsPriority.High:
                return Resources.getResource('panel.news.Priority_1');
            case NewsPriority.Middle:
                return Resources.getResource('panel.news.Priority_5');
            case NewsPriority.Low:
                return Resources.getResource('panel.news.Priority_10');
            default:
                return Resources.getResource('panel.news.Priority_All');
        }
    }
    ColumnCount() {
        return NewsItem.columnsParams.length;
    }
    GetColumnParams(column) {
        const result = NewsItem.columnsParams[column];
        const isHidden = result.DefaultHidden || Resources.isHidden(result.HeaderKey);
        result.Hidden = isHidden;
        result.MenuIndex = this.GetMenuIndex(result.HeaderKey);
        return result;
    }
    GetMenuIndex(headerKey) {
        if (NewsItem.ListMenuIndex.includes(headerKey)) {
            return NewsItem.ListMenuIndex.indexOf(headerKey);
        }
        else {
            return 1000;
        }
    }
}
NewsItem.RECEIVED_COL_INDEX = 0;
NewsItem.SOURCE_COL_INDEX = 1;
NewsItem.SUBJECT_COL_INDEX = 2;
NewsItem.CONTENT_COL_INDEX = 3;
NewsItem.CATEGORY_COL_INDEX = 4;
NewsItem.SYMBOL_COL_INDEX = 5;
NewsItem.PRIORITY_COL_INDEX = 6;
NewsItem.columnsHeaderLocKey = {
    [NewsItem.RECEIVED_COL_INDEX]: 'panel.news.received',
    [NewsItem.SOURCE_COL_INDEX]: 'panel.news.source',
    [NewsItem.SUBJECT_COL_INDEX]: 'panel.news.subject',
    [NewsItem.CONTENT_COL_INDEX]: 'panel.news.context',
    [NewsItem.CATEGORY_COL_INDEX]: 'panel.news.category',
    [NewsItem.SYMBOL_COL_INDEX]: 'panel.news.symbol',
    [NewsItem.PRIORITY_COL_INDEX]: 'panel.news.priority'
};
NewsItem.columnsParams = [
    /* 0 */ new ColumnParams(NewsItem.columnsHeaderLocKey[NewsItem.RECEIVED_COL_INDEX], 75, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams(NewsItem.columnsHeaderLocKey[NewsItem.SOURCE_COL_INDEX], 120, QTAlignment.Left, TableTotalsVisibility.None, true, true),
    new ColumnParams(NewsItem.columnsHeaderLocKey[NewsItem.SUBJECT_COL_INDEX], 120, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams(NewsItem.columnsHeaderLocKey[NewsItem.CONTENT_COL_INDEX], 75, QTAlignment.Left, TableTotalsVisibility.None, false, false),
    new ColumnParams(NewsItem.columnsHeaderLocKey[NewsItem.CATEGORY_COL_INDEX], 75, QTAlignment.Left, TableTotalsVisibility.None, false, false),
    /* 5 */ new ColumnParams(NewsItem.columnsHeaderLocKey[NewsItem.SYMBOL_COL_INDEX], 75, QTAlignment.Left, TableTotalsVisibility.None, false, false),
    new ColumnParams(NewsItem.columnsHeaderLocKey[NewsItem.PRIORITY_COL_INDEX], 75, QTAlignment.Left, TableTotalsVisibility.None, false, false)
];
NewsItem.ListMenuIndex = Object.values(NewsItem.columnsHeaderLocKey);
